import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";

interface LockScreenButtonProps {
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const LockScreenButton: React.FC<LockScreenButtonProps> = ({
  className,
  children = "Lock Screen",
  style,
}) => {
  const navigate = useNavigate();
  const routes = all_routes;

  const handleLockScreen = () => {
    // Check if we have username stored in session storage
    const username = sessionStorage.getItem("lockScreenUsername");

    // Only navigate to lock screen if username exists
    if (username) {
      // Set lock status to true
      sessionStorage.setItem("isScreenLocked", "true");
      navigate(routes.lockScreen);
    } else {
      // If no username is stored, navigate to login instead
      navigate(routes.login);
    }
  };

  return (
    <Link className={className} to="#" onClick={handleLockScreen} style={style}>
      {children}
    </Link>
  );
};

export default LockScreenButton;
